import React, { memo } from 'react';

import { CONSOLE_URL } from 'settings';
import MyModal from 'v2/components/Shared/MyModal';

interface ModalConfirmWebhookCreationProps {
  opened: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const ModalConfirmWebhookCreation = memo(({ opened, onClose, onContinue }: ModalConfirmWebhookCreationProps) => {
  const [showSecondAlert, setShowSecondAlert] = React.useState(false);

  function handleShowHideSecondAlert() {
    setShowSecondAlert(!showSecondAlert);
  }

  function handleShowNewWebhook() {
    if (showSecondAlert) {
      handleShowHideSecondAlert();
    }

    onClose();
    return window.open(`${CONSOLE_URL}/webhook/configs`, '_blank');
  }

  function handleKeepOldWebhook() {
    handleShowHideSecondAlert();
    onClose();
    return onContinue();
  }

  function getModalContent() {
    if (!showSecondAlert) {
      return (
        <>
          <p className='text-sm'>Cadastro de novos webhooks ficarão indisponíveis nesta versão</p>
          <p className='text-sm'>
            A criação de webhooks agora deve ser feita no <strong>Developer Hub</strong>, nosso novo ambiente para
            integrações. Lá, você encontra recursos aprimorados como:
          </p>

          <p className='text-sm'>
            🔹 Redisparo em massa de eventos
            <br />
            🔹 Mais agilidade e facilidade na configuração
            <br />
            🔹 Mais eficiência para lançamentos e grandes volumes
            <br />
            🔹 Canal no Discord para desenvolvedores
            <br />
          </p>

          <p className='text-sm'>
            ⚠️ O webhook atual será <strong>descontinuado em 11/01/2027</strong>.
          </p>
          <p className='text-sm'>
            Recomendamos realizar a migração com antecedência para garantir o funcionamento contínuo das suas
            integrações.
          </p>
          <p className='text-sm'>
            <a href={`${CONSOLE_URL}/webhook/configs`} target='_blank' rel='noopener noreferrer'>
              👉 <strong>[Acessar o novo Webhook no Developer Hub]</strong>
            </a>
          </p>
          <p className='text-sm'>
            <a
              href='https://ajuda.eduzz.com/como-migrar-minhas-integra%C3%A7%C3%B5es-para-a-developer-hub-'
              target='_blank'
              rel='noopener noreferrer'
            >
              🔗 Ver artigo completo sobre a mudança
            </a>
          </p>
        </>
      );
    }

    return (
      <>
        <p className='text-sm'>⚠️ Você está prestes a criar uma integração em uma versão que será descontinuada</p>

        <p className='text-sm'>
          A versão atual do webhook será <strong>desativada em 11/01/2027</strong>.
        </p>

        <p className='text-sm'>
          Continuar usando essa versão pode gerar <strong>retrabalho futuro</strong>, além de{' '}
          <strong>limitações técnicas</strong> em comparação com o novo sistema já disponível no{' '}
          <strong>Developer Hub</strong>.
        </p>

        <p className='text-sm'>No novo webhook você conta com:</p>
        <p className='text-sm'>
          🔹 Redisparo em massa de eventos
          <br />
          🔹 Histórico inteligente e rastreável
          <br />
          🔹 Mais confiabilidade em grandes operações
        </p>
        <p className='text-sm'>
          👉 Para garantir a melhor experiência e evitar ajustes futuros, <strong>recomendamos migrar agora</strong>.
        </p>
      </>
    );
  }

  if (!opened) return null;

  return (
    <MyModal
      opened={opened}
      onSubmit={handleShowNewWebhook}
      onClose={showSecondAlert ? handleKeepOldWebhook : handleShowHideSecondAlert}
      buttonCancel={showSecondAlert ? 'Criar mesmo assim' : 'Continuar na versão atual'}
      buttonOk={showSecondAlert ? 'Usar a nova versão' : 'Acessar Developer Hub'}
      title='Desativação da versão atual do Webhook!'
      disableBackdropClick
    >
      <div className='flex flex-col gap-4'>{getModalContent()}</div>
    </MyModal>
  );
});

export default ModalConfirmWebhookCreation;
